import React from 'react';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { routerShape, withRouter } from 'react-router';
import { EventEmitter } from 'events';
import { getToken, getShop, getShopTimezone } from '../../auth/selectors';
import MFWrapper from '../../common/MFWrapper';
import renderIfChatAvailable from '../renderIfChatAvailable';
import { showNotification } from '../../common/helpers/notifications';
import { containerApp } from '../../../main';

const Chat = React.lazy(() => import('chat/App'));


const ChatPanel = ({
                       isChatOpen,
                       setIsChatOpen,
                       token,
                       shopId,
                       setUnreadMessagesCount,
                       router,
                       fetchAppointment,
                       shopTimezone,
                   }) => {
  const updateUnreadMessages = (conversations) => {
    setUnreadMessagesCount(
            conversations.reduce((acc, conversation) => acc + conversation.getUnreadMessages().length, 0),
        );
  };

  const openCustomerProfile = (customerId) => {
    router.push(`/customers/${customerId}`);
  };

  const openAppointment = async (appointmentId) => {
    EventEmitter.prototype.emit('appointment-clicked', await fetchAppointment(appointmentId));
  };

  return (
    <MFWrapper>
      <Chat
        isOpen={isChatOpen}
        setIsOpen={setIsChatOpen}
        authToken={token}
        shopId={shopId}
        onConversationsChanged={updateUnreadMessages}
        onOpenCustomerProfile={openCustomerProfile}
        onOpenAppointmentInfo={openAppointment}
        timezone={shopTimezone}
        onError={() => showNotification({
          title: 'Connection error',
          message: 'There was an error while trying to load the messages. Please try again.',
        })}
        className="c-chat-panel"
      />
    </MFWrapper>
  );
};

ChatPanel.propTypes = {
  isChatOpen: PropTypes.bool.isRequired,
  setIsChatOpen: PropTypes.func.isRequired,
  token: PropTypes.string.isRequired,
  shopId: PropTypes.string.isRequired,
  setUnreadMessagesCount: PropTypes.func.isRequired,
  router: routerShape.isRequired,
  fetchAppointment: PropTypes.func.isRequired,
  shopTimezone: PropTypes.string.isRequired,
};

export default compose(
    containerApp.hideForContainerApp,
    renderIfChatAvailable,
    connect(state => ({
      token: getToken(state),
      shopId: getShop(state),
      shopTimezone: getShopTimezone(state),
    })),
    withRouter,
)(ChatPanel);
